import {
  Alert,
  Box,
  Collapse,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

// Your components
import { Close, Login } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { activateAccount } from "apis/controllers/users";
import { jwtDecode } from "jwt-decode";
import TextInput from "qubCommon/Inputs/TextInput";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createMarkup } from "util/createMarkup";
import { enqueueSnackbar } from "notistack";


const EmployeeRegisterFormPA = () => {
  if (import.meta.env.MODE === "development") {
    window.serverData = {
      status: "success",
      data: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxMTg4MDIwNjMiLCJ1c2VyX2lkIjoiOTFiOTIyZmMtOTRmNC00MzcwLWJmYWMtMzY3YWI2NDgwNzU5IiwibmJmIjoxNzY0ODYxNjg1LCJleHAiOjE3NjQ4NjE5ODUsImlhdCI6MTc2NDg2MTY4NX0.G3Wnl6kGIjw_McriWs9oe37GTHU39hFn-zxuGriMxjc",
      },
    };
  }

  const methods = useForm();
  const { handleSubmit } = methods;

  const [data] = useState(window.serverData || {});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let decodedData;
  try {
    decodedData = jwtDecode(data?.data?.token);
  } catch (e) {
    console.log(e);
  }

  const onSubmit = async (submitData) => {
    if (loading) return;  // ⛔ block double submits
    setError("");
    try {
      setLoading(true);
      const res = await activateAccount({
        AMKA: submitData?.amka,
        token: data?.data?.token,
      });
      const { status } = res;

      if (status === "error") {
        setError(res?.message);
      } else if (status === "empty") {
        setError("Παρακαλώ συμπληρώστε τα πεδία.");
      } else if (status === "success") {
        enqueueSnackbar(res?.message, { variant: "success" });
        navigate("/govnr/login");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          p: 4,
          maxWidth: 900,
          mx: "auto",
          bgcolor: "#fff",
          borderRadius: 2,
        }}
      >
        {/* Title */}
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
          Το TaxisNet σας πιστοποίησε, εισάγετε τον ΑΜΚΑ σας για είσοδο.
        </Typography>

        {/* Warning Box */}
        <Alert
          severity="error"
          icon={false}
          sx={{
            mb: 3,
            bgcolor: "secondary.main",
            color: "white",
            fontWeight: 500,
          }}
        >
          «Όποιος εν γνώσει του δηλώνει ψευδή γεγονότα ή αρνείται ή αποκρύπτει
          τα αληθή με έγγραφη υπεύθυνη δήλωση του άρθρου 8 τιμωρείται με
          φυλάκιση τουλάχιστον τριών μηνών. Εάν ο υπαίτιος αυτών των πράξεων
          σκοπείται να προσπορίσει στον εαυτόν του ή σε άλλον περιουσιακό όφελος
          βλάπτοντας τρίτον ή σκοπεί να βλάψει άλλον, τιμωρείται με κάθειρξη
          μέχρι 10 ετών.»
        </Alert>

        {/* Form */}
        <Grid container spacing={3}>
          {/* ΑΦΜ */}
          <Grid item xs={12} md={6}>
            <TextInput
              id="afm"
              name="afm"
              label="ΑΦΜ"
              isFullWidth
              rules={{ required: "Απαιτείται ΑΦΜ" }}
              disabled
              defaultValue={decodedData?.nameid}
            />
          </Grid>

          {/* ΑΜΚΑ */}
          <Grid item xs={12} md={6}>
            <TextInput
              id="amka"
              name="amka"
              label="ΑΜΚΑ"
              isFullWidth
              rules={{ required: "Απαιτείται ΑΜΚΑ" }}
            />
          </Grid>
        </Grid>
        <Collapse in={!!error}>
          <Alert
            sx={{ marginTop: 4 }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError("");
                }}
              >
                <Close fontSize="inherit" />
              </IconButton>
            }
            variant="filled"
            severity="error"
          >
            <div dangerouslySetInnerHTML={createMarkup(error)} />
          </Alert>
        </Collapse>
        {/* Submit button */}
        <Grid sx={{ width: "100%" }} item>
          <LoadingButton
            variant="contained"
            startIcon={<Login />}
            loading={loading}
            sx={{ marginTop: 6, mx: "auto" }}
            onClick={handleSubmit(onSubmit)}
          >
            Δημιουργία Λογαριασμού
          </LoadingButton>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default EmployeeRegisterFormPA;
